import React, { useState } from 'react';
import { createStudentNote } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';
import './_Modal.css';

const CreateNoteModal = ({ studentId, onClose, onNoteCreated }) => {
    const [text, setText] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!text) {
            setError('Please enter a note.');
            return;
        }

        try {
            await createStudentNote(studentId, { text });
            onNoteCreated();
            onClose();
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>X</button>
                <h2>Create New Note</h2>
                {error && <p className="error">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <textarea
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                            rows="5"
                        />
                    </div>
                    <div className="actions-centered">
                        <button type="button" onClick={onClose} className="cancel-button text-button">Cancel</button>
                        <button type="submit" className="submit-button text-button">Create</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateNoteModal;